(function($) {

$(document).ready(function() {
  collection.init();
});

if ($(".engoj-collection-sidebar")) {
  History.Adapter.bind(window, 'statechange', function() {
    var State = History.getState();
    if (!collection.fillterClick) {
      collection.filterParams();
      var newurl = collection.filterCreateUrl();
      collection.filterGetContent(newurl);
      collection.syncFilterStates();
    }
    collection.fillterClick = false;
  });
}


var collection = {
  init: function() {

    /* Collection Filter */
    this.initCollectionFilter();

  /* Collection Sorting */
    this.initCollectionSorting();

  },


  /* --------------------------------------------------------- */
  /* Review */
  initReview: function() {

      // return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();

  },

  /* Hide Dropdown */
  initToggle: function(){

  },

  /* --------------------------------------------------------- */
  /* Categories Fillter */

  filterCategories: function() {

  },

  fillterTagEvents: function() {
      $("body").delegate('.filter-tag a:not(".clear"), .filter-tag label', 'click', function(e) {
          e.preventDefault();
          
          let $clicked = $(this);
          let $input = $clicked.prev('input[type="checkbox"]');
          
          // Toggle checkbox using native toggleAttribute
          $input[0].toggleAttribute('checked');
          
          // Toggle classes
          $clicked.toggleClass('active');
          
          let key = $input.attr('name');
          let value = $input.val();
          
          // Initialize array if doesn't exist
          if (!Array.isArray(Shopify.queryParams[key])) {
              Shopify.queryParams[key] = [];
          }
          
          if ($input[0].hasAttribute('checked')) {
              if (!Shopify.queryParams[key].includes(value)) {
                  Shopify.queryParams[key].push(value);
              }
          } else {
              Shopify.queryParams[key] = Shopify.queryParams[key].filter(item => item !== value);
          }
          
          // Remove key if no values
          if (Shopify.queryParams[key].length === 0) {
              delete Shopify.queryParams[key];
          }
          
          collection.filterAjaxClick();
      });
  },

  filterMapClearAll: function() {
    // Clear all selection
    $("body").delegate('.refined-widgets a.clear-all', 'click', function(e) {
        e.preventDefault();
        
        // Clear all filter parameters
        Object.keys(Shopify.queryParams).forEach(key => {
            // Only clear filter parameters, keep other params like sort_by
            if (key.startsWith('filter.')) {
                delete Shopify.queryParams[key];
            }
        });
        
        delete Shopify.queryParams.q;
        
        // Reset UI
        $('.filter-tag a:not(".clear"), .filter-tag label').removeClass('active');
        $('.filter-tag input').removeAttr('checked');
        
        collection.filterAjaxClick();
    });

    // Individual filter clear
    $("body").delegate('.filter-block .clear', 'click', function(e) {
        e.preventDefault();
        var filterTag = $(this).parent().parent();
        var filterKey = filterTag.find('input').first().attr('name');
        
        // Clear the specific filter
        delete Shopify.queryParams[filterKey];
        
        // Reset UI for this filter group
        filterTag.find("a").removeClass("active");
        filterTag.find("input").removeAttr('checked');
        
        collection.filterAjaxClick();
    });
  },

//     filterMapClear: function() {
//         $(".filter-tag").each(function() {
//           var filterTag = $(this);
//           if (filterTag.find("input:checked").length > 0) {
//               //has active tag
//               filterTag.find(".clear").show();
//           }
//         });
//     },
  
  filterMapClear: function() {
    $(".filter-tag").each(function() {
      var filterTag = $(this);
      if (filterTag.find("input:checked").length > 0) {
        filterTag.find(".clear").show();
      } else {
        filterTag.find(".clear").hide();
      }
    });
  }, 
  

  filterParams: function() {
      Shopify.queryParams = {};
      if (location.search.length) {
          // Group parameters by key
          let params = new URLSearchParams(location.search);
          let paramGroups = {};

          // Group all values for each key and remove duplicates
          for (let [key, value] of params.entries()) {
              if (!paramGroups[key]) {
                  paramGroups[key] = new Set();
              }
              paramGroups[key].add(value);
          }

          // Set parameters in Shopify.queryParams
          for (let key in paramGroups) {
              // Single value filters
              if (key === 'sort_by' || key === 'filter.v.price') {
                  // These filters can only have one value
                  Shopify.queryParams[key] = Array.from(paramGroups[key])[0];
              } 
              // Multiple value filters
              else {
                  // All other filters can have multiple values (color, size, vendor, etc)
                  Shopify.queryParams[key] = Array.from(paramGroups[key]);
              }
          }
      }
  },

  filterMapEvents: function() {
      collection.fillterTagEvents();
  },

  syncFilterStates: function() {
    // First clear all active states and checkboxes
    $(".filter-custom .active, .filter-links .active").removeClass("active");
    $(".filter-tag input:checked").prop('checked', false);
    $(".filter-tag input").removeAttr('checked');
    $(".collection-sorting li").removeClass("active");

    // Get all unique filter names from inputs
    let filterInputs = $('.filter-tag input[type="checkbox"]');
    let filterNames = [...new Set(filterInputs.map(function() {
        return $(this).attr('name');
    }).get())];

    // Set active states for each filter type
    filterNames.forEach(filterName => {
        if (Shopify.queryParams[filterName]) {
            let selectedValues = Array.isArray(Shopify.queryParams[filterName]) 
                ? Shopify.queryParams[filterName] 
                : [Shopify.queryParams[filterName]];

            selectedValues.forEach(value => {
                $(`.filter-tag input[name="${filterName}"][value="${value}"]`).each(function() {
                    let $input = $(this);
                    $input[0].toggleAttribute('checked', true);
                    $input.next('a').addClass('active');
                });
            });
        }
    });

    // Handle sorting separately since it's not a filter
    if (Shopify.queryParams.sort_by) {
        let $sortLink = $('.collection-sorting a[href="' + Shopify.queryParams.sort_by + '"]');
        if ($sortLink.length) {
            $sortLink.parent('li').addClass('active');
            let selectedText = $sortLink.text();
            $sortLink.closest('.dropdown').find('.dropdown-label').text(selectedText);
        }
    } else {
        $('.collection-sorting a[href="manual"]').parent('li').addClass('active');
    }

    // Update clear buttons visibility
    collection.filterMapClear();
  },

  filterMapData: function(data) {
      var currentList = $(".grid-uniform");

      var productList = $(data).find(".grid-uniform");

      currentList.replaceWith(productList);

      //replace paging
      if ($(".pagination").length > 0) {
        $(".pagination").replaceWith($(data).find(".pagination"));
      };

      $('.filter-blocks').replaceWith($(data).find(".filter-blocks"));
      
      // Re-sync filter states after updating DOM
      collection.syncFilterStates();
      collection.filterMapClear();
      quickView();
      var ajaxCartConfig = {
        cartContainer: '.enj-minicart-ajax',
        addToCartSelector: '.enj-add-to-cart-btn',
        cartCountSelector: '.enj-cartcount',
        cartCostSelector: '.enj-cartcost',
        moneyFormat: null
      };
        jQuery(function($) {
        ajaxCart.init(ajaxCartConfig);
      });
    
      function loadmore() {
        $('.loadmore').children('a').on('click',function(e){
          $('.loadmore').addClass('d-none');
          $('.loading.tshopify-popup').addClass('active');
          var link = $('.loadmore').children('a').attr('href');
          if (link != '#' ) {
            $('.load-data').load(link+' .product-grid-view .row')

            setTimeout(function(){
              $('.load-data .js_loadmore').each(function(){$(this).appendTo('.product-grid-view .row')})
              //           $('.loadmore').appendTo('.collection_prod .product-grid-view row')
              $('.loadmore').eq(0).remove();
              loadmore();
              quickView();
              var ajaxCartConfig = {
                cartContainer: '.enj-minicart-ajax',
                addToCartSelector: '.enj-add-to-cart-btn',
                cartCountSelector: '.enj-cartcount',
                cartCostSelector: '.enj-cartcost',
                moneyFormat: null
              };
                jQuery(function($) {
                ajaxCart.init(ajaxCartConfig);
              });

              $('.loading.tshopify-popup').removeClass('active');
            },2000)
          } else {
            $('.loadmore').remove();
          }
          e.preventDefault();
        })
      }
      loadmore();
    
    
      jQuery('.engoj_select_color a').each(function(){
        jQuery(this).on("click",function(){
          var engoImage = jQuery(this).data('engojvariant-img');
          jQuery(this).parents('.engoj_grid_parent').find('.engoj_find_img img').attr({ src: engoImage }); 
          return false;
        });
      });

  },

  filterCreateUrl: function(baseLink) {
      let params = new URLSearchParams();
      
      // Convert Shopify.queryParams to URL parameters
      Object.keys(Shopify.queryParams).forEach(key => {
          if (Array.isArray(Shopify.queryParams[key])) {
              // Add each value separately for arrays
              Shopify.queryParams[key].forEach(value => {
                  params.append(key, value);
              });
          } else {
              // Handle single value params (like sort_by)
              params.set(key, Shopify.queryParams[key]);
          }
      });
      
      let newQuery = params.toString();
      
      if (baseLink) {
          return newQuery ? baseLink + "?" + newQuery : baseLink;
      }
      return location.pathname + (newQuery ? "?" + newQuery : "");
  },

  filterAjaxClick: function(baseLink) {
    delete Shopify.queryParams.page;
    var newurl = collection.filterCreateUrl(baseLink);
    collection.fillterClick = true;
    History.pushState({
      param: Shopify.queryParams
    }, newurl, newurl);
    collection.filterGetContent(newurl);
  },

  filterGetContent: function(newurl) {

    $.ajax({
      type: 'get',
      url: newurl,
      beforeSend: function() {
        showPopup('.loading');
      },

      success: function(data) {

        collection.filterMapData(data);

        collection.filterMapClear();
        hidePopup('.loading');
        hidePopup('.filter-to-left , .js-bg');
    
      },

      error: function(xhr, text) {
        hidePopup('.loading');
        hidePopup('.filter-to-left, .js-bg');
        $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
        showPopup('.ajax-error-modal');
      }

    });
  },



  initCollectionFilter: function() {
    if ($(".engoj-collection-sidebar").length > 0) {
        collection.filterParams();        // 1. Parse URL parameters
        collection.filterMapEvents();     // 2. Setup event handlers
        collection.filterMapClear();      // 3. Setup clear buttons
        collection.filterMapClearAll();   // 4. Setup clear all functionality
        collection.syncFilterStates();    // 5. Updated name here: Sync UI with URL params
    }
  },

  /* --------------------------------------------------------- */
  /* Collection Sorting */
  initCollectionSorting: function(e) {
    $(".collection-sorting a").click(function(e) {
      e.preventDefault();     
      if (!$(this).parent().hasClass("active")) {   
        Shopify.queryParams.sort_by = $(this).attr("href");
        collection.filterAjaxClick();    
        $(".collection-sorting li.active").removeClass("active");
        $(this).parent().addClass("active");
      }    
      var selected = $(this).text();   
      $(this).closest('.dropdown').find('.dropdown-label').text(selected);
      $(this).closest('.dropdown-content').removeClass('active');  

    });
  },

  /* --------------------------------------------------------- */
  /* Collection View Mode */
  initCollectionViewMode: function() {

  },


  /* --------------------------------------------------------- */
  /* Collection Show */
  initCollectionShow: function() {

  },

  /* --------------------------------------------------------- */
  /* Paging */
  initPaging: function() {

  },

}

})(jQuery);